import { render, staticRenderFns } from "./ArticleNavActions.vue?vue&type=template&id=d7949c9e&"
import script from "./ArticleNavActions.vue?vue&type=script&lang=ts&"
export * from "./ArticleNavActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports